<template>
	<div class="alert" @click.stop="close">
		<div class="alert-box">
			<div class="title">

				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;活动说明&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body">
				<div class="info">
					1. 每名用户每日成功签到一次，可获得1次抽奖机会；
					<br />2. 首次输入手机号验证登陆后，可获得5次抽奖机会；
					<br />3. 修容阁每日分享成功后可额外获得1次抽奖机会；
					<br />4. 2月9日 18:00点开启预下载，预下载当天，成功签到后，可额外获得5次抽奖机会；
					<br />5. 2月10日公测当天，成功签到后，可额外获得5次抽奖机会；
					<br />6. 2月11日零点之前完成手游安装并注册，可额外获得20次抽奖机会
					<br />7. 奖品分为游戏礼包奖励与实物奖励；
					<br />8. 游戏公测后，使用同一手机号在本APP内下载登陆游戏服务器，可在“个人中心”领取游戏礼包奖励；
					<br />9.
					实物奖励中奖后，用户可在个人中心中查看奖励并填写个人信息，游戏公测时使用同一手机号在本APP内下载登陆游戏服务器后安排发货。用户未在限定时间内填写个人收货信息，则视为主动放弃实物奖励；
					<br />10. 本次活动解释权归《我的门派》手游官方所有。

				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "alert",
		data() {
			return {};
		},
		created() {

		},
		computed: {

		},
		methods: {
			close() {
				this.$emit('close')
			}
		},
	};
</script>
<style scoped>
	.alert {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.2);
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.alert-box {
		border-radius: 6px;
		width: 80%;
		left: 10%;
		margin: 0 auto;
		position: fixed;
		top: 60px;
		overflow: hidden;
	}

	.title {
		background-color: #F6E9B2;
		color: #686e3f;
		padding: 6px;
	}

	.body {
		background-color: #E4C677;
		padding: 10px;

	}

	.info {
		border-radius: 6px;
		background-color: #F6E9B2;
		text-align: left;
		padding: 10px;
		color: #BD8E5B;
		max-height: 400px;
		overflow-y: scroll;
	}

	.decorate {
		width: 20%;
	}
</style>
